import React,{ useState } from 'react';
import { useNavigate } from 'react-router-dom';

// icons
import { FaCheck } from 'react-icons/fa';

// components
import CommonModal from '../../../components/modal/CommonModal';

// utils
import { validateConfirmPW, validatePW } from '../../../utils/validation';
import { hasForbiddenChars, FORBIDDEN_CHARS_MSG } from '../../../utils/sanitize';

// api
import { changePWWithOrigin } from '../../../services/apis/auth';

function HearroMyPageModifyPW() {
	const navigate = useNavigate();
	const [password, setPassword] = useState({ prev: '', new: '', confirm: '' });
	const [isNonValidPW, setIsNonValidPW] = useState(false);

	const [showModifyModal, setShowModifyModal] = useState(false);

	function goToMyPageMain() {
		navigate('/dtx002/mypage');
	}

	const handleSubmit = async () => {
		if (
			hasForbiddenChars(password.prev) ||
			hasForbiddenChars(password.new) ||
			hasForbiddenChars(password.confirm)
		) {
			setIsNonValidPW(true);
			return;
		}

		if (Object.values(password).some(e => e === '')) {
			alert('모든 입력값은 필수입니다.');
			return;
		}

		if (
			validatePW(password.new, password.prev) !== 'valid' ||
			validateConfirmPW(password.new, password.confirm) !== 'valid'
		) {
			return;
		}

		try {
			// const tokenInfo = JSON.parse(localStorage.getItem('dtx002token'));
			const username = localStorage.getItem('saveId');
			const request = {
				username,
				originPassword: password.prev,
				newPassword: password.new,
			};
			const res = await changePWWithOrigin(request);
			if (parseInt(res.status / 200, 10) === 1) {
				setIsNonValidPW(false);
				setShowModifyModal(true);
			} else if (
				res.response &&
				res.response.data &&
				res.response.data.code === 'Need-a-different-password'
			) {
				alert(res.response.data.message);
			} else {
				setIsNonValidPW(true);
			}
		} catch (err) {
			console.error(err);
			setIsNonValidPW(true);
		}
	};

	const closeModifyModal = () => {
		setShowModifyModal(false);
		navigate('/dtx002/mypage');
	};

	const ModifyModalBody = <div className="mypage_modal_body">비밀번호가 변경되었습니다.</div>;

	const ModifyModalFooter = (
		<div className="mypage_modal_footer">
			<button className="submit complete" type="button" onClick={closeModifyModal}>
				확인
			</button>
		</div>
	);

	return (
		<div className="dashboardContent">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지</span>
			</div>
			<div className="mypage_center_box_wrapper">
				<div className="title_wrapper">
					<div className="title">비밀번호 변경</div>
					<div className="description">
						- 영문, 숫자, 특수기호 중 3개 이상 조합으로 8~20자 입력해주세요.
						<br />- 아이디, 전화번호 등 개인정보와 관련된 숫자 등은 사용하지 마세요.
					</div>
				</div>
				<div className="center_box">
					<div className="input_wrapper modify_pw_input_wrapper">
						<div className="input_label">현재 비밀번호</div>
						<input
							type="password"
							value={password.prev}
							onChange={e => {
								setIsNonValidPW(false);
								setPassword({ ...password, prev: e.target.value });
							}}
							maxLength={20}
							style={{ borderColor: isNonValidPW ? '#DC3545' : '#707070' }}
						/>
						{hasForbiddenChars(password.prev) && (
							<div className="validation" style={{ color: '#DC3545' }}>{FORBIDDEN_CHARS_MSG}</div>
						)}
						{isNonValidPW && <div className="validation">Error</div>}
					</div>
					<div className="input_wrapper modify_pw_input_wrapper">
						<div className="input_label">새로운 비밀번호</div>
						<div className="input_item_wrapper">
							<input
								className={`input_with_icon ${
									validatePW(password.new, password.prev) === 'valid' && 'valid_input'
								}  ${validatePW(password.new, password.prev) === 'non-valid' && 'non_valid_input'}`}
								type="password"
								value={password.new}
								onChange={e => {
									setPassword({ ...password, new: e.target.value });
								}}
								maxLength={20}
							/>
							{validatePW(password.new, password.prev) === 'valid' && (
								<div className="valid_icon">
									<FaCheck />
								</div>
							)}
						</div>
						{validatePW(password.new, password.prev) === 'non-valid' && (
							<div className="validation">사용할 수 없는 비밀번호입니다.</div>
						)}
						{validatePW(password.new, password.prev) === 'valid' && (
							<div className="validation success">사용가능한 비밀번호 입니다.</div>
						)}
					</div>
					<div className="input_wrapper modify_pw_input_wrapper">
						<div className="input_label">새로운 비밀번호 확인</div>
						<div className="input_item_wrapper">
							<input
								className={`input_with_icon ${
									validateConfirmPW(password.new, password.confirm) === 'valid' && 'valid_input'
								}  ${
									validateConfirmPW(password.new, password.confirm) === 'non-valid' &&
									'non_valid_input'
								}`}
								type="password"
								value={password.confirm}
								onChange={e => {
									setPassword({ ...password, confirm: e.target.value });
								}}
								maxLength={20}
							/>
							{validateConfirmPW(password.new, password.confirm) === 'valid' && (
								<div className="valid_icon">
									<FaCheck />
								</div>
							)}
						</div>
						{validateConfirmPW(password.new, password.confirm) === 'non-valid' && (
							<div className="validation">비밀번호가 일치하지 않습니다.</div>
						)}
						{validateConfirmPW(password.new, password.confirm) === 'valid' && (
							<div className="validation success">비밀번호가 일치합니다.</div>
						)}
						{hasForbiddenChars(password.confirm) && (
							<div className="validation" style={{ color: '#DC3545' }}>{FORBIDDEN_CHARS_MSG}</div>
						)}
					</div>
					<div className="button_wrapper">
						<button className="submit" onClick={handleSubmit}>
							확인
						</button>
						<button className="cancel" onClick={goToMyPageMain}>
							취소
						</button>
					</div>
				</div>
				<CommonModal
					header="비밀번호 변경"
					body={ModifyModalBody}
					footer={ModifyModalFooter}
					show={showModifyModal}
					setClose={closeModifyModal}
					size="sm"
				/>
			</div>
		</div>
	);
}

export default HearroMyPageModifyPW;
